// extracted by mini-css-extract-plugin
module.exports = {"button":"_3VWtHd","whiteColor":"_1t4_bm","icon":"_1dvznN","brandColor":"_2XDiIv","shine-lines":"_13_qQK"};